import tw from 'tailwind-styled-components';
import FadeInSection from '../../components/FadeInSection';

import NextImage from 'components/NextImage';
import { ImagesService } from 'service/images/imagesService';

import { ReactNode } from 'react';
import { IAsset } from './index';

const TopRight = tw.div`
  absolute
  -top-8
  -right-8
  md:-right-24
  w-metaBallMobile
  h-metaBallMobile
  md:w-metaBall
  md:h-metaBall
`;

const TopLeft = tw.div`
  absolute
  top-5
  md:-left-28
  sm:-top-10
  sm:-left-10
  md:w-metaBall
  md:h-metaBall
  sm:w-metaBallMobile
  sm:h-metaBallMobile
`;

const BottomRight = tw.div`
  absolute
  bottom-12
  md:-right-24
  sm:-right-10
  md:w-metaBall
  md:h-metaBall
  sm:w-metaBallMobile
  sm:h-metaBallMobile
`;

const BottomLeft = tw.div`
  absolute
  md:-bottom-96
  sm:-bottom-96
  md:-left-28
  sm:-left-10
  md:h-metaBall
  md:w-metaBall
  sm:w-metaBallMobile
  sm:h-metaBallMobile
`;
export const ContainerStyle = 'relative my-0 p-0 min-w-full z-40 overflow-hidden';

interface IHeroWrapperContainerProps {
  children: ReactNode;
  topLeftImage?: string;
  topRightImage?: IAsset | null;
  bottomLeftImage?: IAsset | null;
  bottomRightImage?: string;
}

export const HeroWrapperContainer = ({
  children,
  topRightImage,
  bottomRightImage,
  bottomLeftImage,
  topLeftImage,
}: IHeroWrapperContainerProps) => (
  <section data-testid="hero-wrapper-container" className={ContainerStyle} data-print="hide">
    {topRightImage && (
      <FadeInSection>
        <TopRight>
          <div className="relative">
            <NextImage
              sources={ImagesService.getPictureSources(topRightImage)}
              className="z-50 absolute "
              alt=""
            />
          </div>
        </TopRight>
      </FadeInSection>
    )}
    {bottomRightImage && (
      <FadeInSection>
        <BottomRight>
          <div className="relative">
            <NextImage
              src={bottomRightImage}
              alt=""
              className="z-20 absolute"
              width={300}
              height={300}
            />
          </div>
        </BottomRight>
      </FadeInSection>
    )}
    {bottomLeftImage && (
      <FadeInSection>
        <BottomLeft>
          <div className="relative">
            <NextImage
              sources={ImagesService.getPictureSources(bottomLeftImage)}
              className="z-20 absolute"
              alt=""
            />
          </div>
        </BottomLeft>
      </FadeInSection>
    )}
    {topLeftImage && (
      <FadeInSection>
        <TopLeft>
          <div className="relative">
            <NextImage
              src={topLeftImage}
              alt=""
              className="z-20 absolute"
              width={300}
              height={300}
            />
          </div>
        </TopLeft>
      </FadeInSection>
    )}
    {children}
  </section>
);
